import React, { memo, useCallback, useState } from 'react';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { addParamsToUrl, getLocationParams } from 'js/utils/url.util';

import * as Types from './types';

import style from './Image.scss';

export const ImageBare: React.FC<Types.IImageProps> = ({
      alt,
      className,
      draggable,
      fallbackSrc,
      imageRef,
      onError,
      src,
      ...props
}) => {
    const isMounted = useIsMounted();
    const [failedImgSrc, setFailedImgSrc] = useState<string>('');
    const shouldUseFallbackImg = Boolean(fallbackSrc && failedImgSrc === src);

    // it is really important to add query string parameters here
    // because in hub2-shared environment we must pass parameters to
    // all local assets
    const imageURLWithParams = addParamsToUrl(getLocationParams(), src);
    const fallbackImageURLWithParams = fallbackSrc && addParamsToUrl(getLocationParams(), fallbackSrc);

    const onImageError = useCallback((event: React.SyntheticEvent<HTMLImageElement>): void => {
        isMounted() && setFailedImgSrc(src);

        onError && onError(event);
    }, [src, onError, setFailedImgSrc, isMounted]);

    return (
        <>
            {!shouldUseFallbackImg && (
                <img
                    alt={alt}
                    ref={imageRef}
                    draggable={draggable}
                    onError={onImageError}
                    src={imageURLWithParams}
                    className={`${style.image} ${className}`}
                    {...props}
                />
            )}
            {shouldUseFallbackImg && (
                <img
                    alt={alt}
                    ref={imageRef}
                    draggable={draggable}
                    src={fallbackImageURLWithParams}
                    className={`${style.image} ${className}`}
                    {...props}
                />
            )}
        </>
    );
};

export const Image = memo(ImageBare);

// todo Remove this
export default Image;
